import type {
  ExtractionTarget,
  FieldEntityTarget,
  StakeholderType
} from '@gat-ship/types'

/** Maps a stakeholder type to its custom-field entity target. */
export const stakeholderTypeToTarget: Record<
  StakeholderType,
  FieldEntityTarget
> = {
  client: 'Stakeholder.Client',
  vendor: 'Stakeholder.Vendor',
  other: 'Stakeholder.OtherParty'
}

/** Smart-paste extraction target for creating a stakeholder of the given type. */
export function getCreateSmartPasteTarget(
  stakeholderType: StakeholderType
): ExtractionTarget {
  if (stakeholderType === 'client') {
    return 'DE:Stakeholders.V1.CreateClient'
  }
  if (stakeholderType === 'vendor') {
    return 'DE:Stakeholders.V1.CreateVendor'
  }
  return 'DE:Stakeholders.V1.CreateOtherParty'
}
